firebird.controller('createE2EEncryptionKeyCtrl', [
    '$rootScope',
    '$scope',
    '$window',
    'localizationService',
    'growlService',
    'analyticsWrapperService',
    function ($rootScope, $scope, $window, localizationService, growlService, analyticsWrapperService) {
        var self = this;

        self.e2eeKey = '';
        self.modalState = 'closed';
        self.emptyEncryptionKey = false;
        self.invalidEncryptionKey = false;
        self.e2eeKeyPattern = /^[0-9a-zA-Z]+$/;

        self.cancel = function (confirmed) {
            if (!confirmed) {
                analyticsWrapperService.eventTrack(
                    'Meeting - E2EE - Host canceled encryption enabling on enter key popup'
                );
            }
            self.modalState = 'closed';
        };

        $window.$('#createE2EEncryptionKey').on('shown.bs.modal', function () {
            $window.$('#e2eeKey').focus();
        });
        self.onInputChange = function () {
            self.emptyEncryptionKey = false;
            self.invalidEncryptionKey = false;
        };

        self.copyEncryptionKeyToClipboard = function () {
            var options = {
                parentElementId: 'createE2EEncryptionKey',
                successCallback: self.copyEncryptionKeySuccessCallback,
                errorCallback: self.copyEncryptionKeyFailCallback
            };
            $rootScope.$broadcast('copy-text-to-clipboard', { text: self.e2eeKey, options: options });
        };

        self.enableE2EE = function () {
            var key = (self.e2eeKey || '').trim().substring(0, 16);

            if (key.length === 0) {
                self.e2eeKey = '';
                self.emptyEncryptionKey = true;

                return;
            }

            if (key.length < 4 || !key.match(self.e2eeKeyPattern)) {
                self.invalidEncryptionKey = true;

                return;
            }

            self.cancel(true);

            $rootScope.$broadcast('enable-e2ee', { e2eeKey: key });
        };

        self.copyEncryptionKeySuccessCallback = function () {
            growlService.show(localizationService.translate('NOTIFICATIONS.COPIED_TO_CLIPBOARD'), 'success');
        };

        self.copyEncryptionKeyFailCallback = function () {
            growlService.show(
                localizationService.translate('HEADER.SECURITY.NOTIFICATION.FAILED_COPY_ENCRYPTION_KEY_TO_CLIPBOARD'),
                'danger'
            );
        };

        $scope.$on('show-modal', function (e, modalName) {
            if (modalName === 'createE2EEncryptionKey') {
                resetState();
                self.modalState = 'open';
            }
        });

        function resetState() {
            self.emptyEncryptionKey = false;
            self.invalidEncryptionKey = false;
            self.e2eeKey = '';
        }
    }
]);
